"use strict";
var _a;
Object.defineProperty(exports, "__esModule", { value: true });
exports.HELMET_TEXTURE_MAPPING = exports.HelmetType = void 0;
/**
 * Types of helmet
 */
var HelmetType;
(function (HelmetType) {
    HelmetType["Spartan"] = "spartan";
    HelmetType["Hood"] = "hood";
})(HelmetType || (exports.HelmetType = HelmetType = {}));
/**
 * Maps the helmet type to its possible textures
 */
exports.HELMET_TEXTURE_MAPPING = (_a = {},
    _a[HelmetType.Spartan] = ["metalKnight", "shogun"],
    _a[HelmetType.Hood] = ["assassin"],
    _a);
